import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { mockGymFinderService } from 'app/features/leads/services/gym-finder';
import type { LeadsListParams } from 'app/features/leads/services/gym-finder/types';

export const leadsListQueryOptions = (params: LeadsListParams) =>
  queryOptions({
    queryKey: ['leads', 'list', params],
    queryFn: () => mockGymFinderService.listLeads(params),
    placeholderData: keepPreviousData,
  });
